import RecommendedAnswer from 'models/recommended_answer';
import createConverter from './lib/create_converter';

export default createConverter(RecommendedAnswer);
